(() => {
  const nativeSelectors = [
    '.quick-add__submit',
    '.product-form__submit',
    '[id^="quick-add-"][id$="-submit"]',
    '[id^="ProductSubmitButton-"]'
  ].join(',');

  const scopeSelectors = [
    '.product-card-wrapper',
    '.quick-add',
    '.product__info-container',
    '.featured-product',
    'product-info'
  ].join(',');

  const getText = (element) => (element.value || element.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();

  const isVisible = (element) => {
    if (!element || element.closest('[hidden], [aria-hidden="true"]')) return false;
    if (element.disabled || element.getAttribute('aria-disabled') === 'true') return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const isNativeButton = (element) => element.matches(nativeSelectors);

  const isCowlendarBookButton = (element) => {
    if (isNativeButton(element)) return false;
    if (element.closest('.shopify-payment-button')) return false;
    return getText(element) === 'book now' && isVisible(element);
  };

  const hideElement = (element) => {
    if (!element || element.dataset.sasCowlendarHidden === 'true') return;

    element.dataset.sasCowlendarHidden = 'true';
    element.hidden = true;
    element.style.setProperty('display', 'none', 'important');
  };

  const restoreElement = (element) => {
    delete element.dataset.sasCowlendarHidden;
    element.hidden = false;
    element.style.removeProperty('display');
  };

  const reconcileScope = (scope) => {
    const buttons = Array.from(scope.querySelectorAll('button, a, input[type="button"], input[type="submit"], [role="button"]'));
    const hasCowlendarBookButton = buttons.some(isCowlendarBookButton);

    if (!hasCowlendarBookButton) {
      scope.querySelectorAll('[data-sas-cowlendar-hidden="true"]').forEach(restoreElement);
      return;
    }

    buttons.forEach((button) => {
      const text = getText(button);
      if (!isNativeButton(button)) return;
      if (text !== 'add to cart' && text !== 'choose options') return;

      hideElement(button);

      const wrapper = button.closest('.quick-add > *, .product-form__buttons > *');
      if (wrapper && wrapper !== button && !wrapper.classList.contains('shopify-payment-button')) {
        hideElement(wrapper);
      }
    });
  };

  const reconcileButtons = () => {
    const scopes = Array.from(document.querySelectorAll(scopeSelectors)).filter(
      (scope) => !scope.parentElement?.closest(scopeSelectors)
    );

    scopes.forEach(reconcileScope);
  };

  const mountHeaderActions = () => {
    const button = document.querySelector('.sas-floating-book');
    const header = document.querySelector('.header-wrapper .header');
    const globalTheme = document.querySelector('.sas-global-theme-section');
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;

    if (!button || !header) return;

    if (!isDesktop) {
      button.dataset.sasHeaderMounted = 'false';
      button.classList.remove('sas-floating-book--mounted');
      if (globalTheme && button.parentElement !== globalTheme) {
        globalTheme.appendChild(button);
      }
      return;
    }

    if (button.dataset.sasHeaderMounted === 'true' && button.parentElement === header) return;

    button.dataset.sasHeaderMounted = 'true';
    button.classList.add('sas-floating-book--mounted');
    header.appendChild(button);
  };

  const init = () => {
    mountHeaderActions();
    reconcileButtons();

    document.querySelectorAll('.product-grid, .product-card-wrapper, product-info, .featured-product').forEach((target) => {
      if (target.dataset.sasCowlendarObserver === 'true') return;

      target.dataset.sasCowlendarObserver = 'true';
      new MutationObserver(reconcileButtons).observe(target, { childList: true, subtree: true, characterData: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  document.addEventListener('variant:change', reconcileButtons);
  window.addEventListener('resize', mountHeaderActions);

  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  if (headerGroup) {
    new MutationObserver(mountHeaderActions).observe(headerGroup, { childList: true, subtree: true });
  }
})();
